"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinCard;
var _react = _interopRequireDefault(require("react"));
var _SpinResults = _interopRequireWildcard(require("../SpinResults"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
var _uxUtils = require("@site/ux-utils");
var _classnames = _interopRequireDefault(require("classnames"));
var _sharedComponents = require("@site/shared-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

function SpinCard({
  domain,
  product,
  ctaProps,
  options,
  language,
  enableDynamicFontScaling,
  PriceBlock,
  AddToCartButton,
  customClassName,
  hideIcon = false,
  onClick,
  isConversationalSearch = false,
  dataEid,
  CustomCartStateBadge,
  expandSpinOnAddToCart
}) {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const {
    pricingStyleOverrides
  } = options?.styleOverrides || {};
  const cardPricingStyleOverrides = {
    ...pricingStyleOverrides,
    styleOptions: {
      ...pricingStyleOverrides?.styleOptions,
      alignRight: false,
      addPriceLineMarginTop: false
    },
    ...(!isMobile && {
      styleOverrides: {
        ...pricingStyleOverrides?.styleOverrides,
        mainPriceStyle: {
          ...pricingStyleOverrides?.styleOverrides?.mainPriceStyle,
          fontSize: 'ms2'
        }
      }
    }),
    priceDisclaimerWrapper: (0, _classnames.default)(pricingStyleOverrides?.priceDisclaimerWrapper, 'spin-card-price-disclaimer')
  };
  const LoadingState = () => /*#__PURE__*/_react.default.createElement("div", {
    className: "px-card-content d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mt-25rem",
    height: "1.75rem",
    width: "85%"
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mt-075rem",
    height: "1.75rem",
    width: "50%"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mt-1",
    height: "1rem",
    width: "60%"
  })), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    height: "4.5rem",
    className: "mt-4 w-45rem"
  }));
  const SpinDomainIcon = !hideIcon ? () => /*#__PURE__*/_react.default.createElement(_sparklesFilled.default, {
    width: 24,
    height: 24,
    fill: "#613EA3"
  }) : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "spin-card",
    "data-testid": "spin-card",
    className: (0, _classnames.default)('spin-card', customClassName, {
      'mb-2': isMobile
    }),
    onClick: onClick
  }, !domain ? /*#__PURE__*/_react.default.createElement(LoadingState, null) : /*#__PURE__*/_react.default.createElement(_SpinResults.default, {
    display: _SpinResults.SPIN_DISPLAY.CARD,
    language: language,
    dataCy: `spin-results-${domain?.Fqdn}`,
    product: product,
    domainEntry: domain,
    ctaProps: ctaProps,
    options: {
      ...options,
      styleOverrides: {
        ...options?.styleOverrides,
        pricingStyleOverrides: cardPricingStyleOverrides
      },
      enableHover: false
    },
    enableDynamicFontScaling: enableDynamicFontScaling,
    SpinDomainIcon: SpinDomainIcon,
    customAddToCartButton: AddToCartButton && /*#__PURE__*/_react.default.createElement(AddToCartButton, {
      domain,
      product,
      isConversationalSearch: isConversationalSearch,
      dataEid: dataEid,
      expandSpinOnAddToCart: expandSpinOnAddToCart
    }),
    customPriceBlock: PriceBlock && /*#__PURE__*/_react.default.createElement(PriceBlock, {
      domain,
      product,
      options: {
        ...options,
        classNames: {
          ...cardPricingStyleOverrides
        }
      },
      enableDynamicFontScaling
    }),
    CustomCartStateBadge: CustomCartStateBadge
  }));
}
SpinCard.propTypes = {
  domain: _propTypes.default.object,
  product: _propTypes.default.object,
  language: _propTypes.default.object,
  options: _propTypes.default.object,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  enableDynamicFontScaling: _propTypes.default.bool,
  ctaProps: _propTypes.default.object,
  customClassName: _propTypes.default.string,
  hideIcon: _propTypes.default.bool,
  onClick: _propTypes.default.func
};